import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { EpicRefined } from 'interfaces/middleware'
import { of, merge } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { CCActivateCardAction, CCOnboardingActions } from 'components/features/creditCard/creditCardStore/actions'
import { CC_ACTIVATE_URL } from 'components/features/creditCard/creditCardStore/endpoints'

export const ccActivationEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions> = (action$, _, { post }) => action$.pipe(
  filterRequest(CCActivateCardAction.type),
  mergeMap((action) => {
    return post({ url: CC_ACTIVATE_URL, params: { uid: action.payload.params.uid }}, { body: {}}).pipe(
      mergeMap(({ response }) => {
        return merge(
          of(action.success(response)),
        )
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response })))
    )
  }),
)
